angular.module('bizmetryApp')
    .controller('DatabasePickerDialogController', function (
        $scope, $mdDialog, $mdToast, $timeout, DatasourceService,
        envMapping, pkAttributes, environment, dialogService, resourceAttributes, maxSelections, existingPKs
    ) {
        var vm = this;
        var pickerClosed = false;
        var loadSequence = 0; // descarta respuestas de búsquedas ya superadas

        vm.envMapping = envMapping;
        vm.pkAttributes = pkAttributes;
        vm.environment = environment;
        vm.resourceAttributes = resourceAttributes;
        vm.maxSelections = maxSelections || null;
        vm.existingPKs = existingPKs || []; // ✅ NUEVO: Lista de PKs ya importados
        vm.loading = false;
        vm.isLoadingAllRecords = false;
        vm.rows = [];
        vm.columns = [];
        vm.allColumns = [];
        vm.selectedRows = [];
        vm.selectAll = false;
        vm.searchText = '';
        vm.highlightTerm = ''; // término de la búsqueda que produjo las filas mostradas
        vm.page = 1;
        vm.pageSize = 10;
        vm.totalRows = 0;
        vm.totalPages = 0;
        vm.hasNextPage = false;
        vm.hasPreviousPage = false;
        vm.visiblePages = [];

        // JSON viewer (biz-json-viewer overlay)
        vm.jsonViewer = { open: false, json: null, title: null };

        console.log('Database Picker initialized with:', {
            envMapping: envMapping,
            pkAttributes: pkAttributes,
            environment: environment,
            resourceAttributes: resourceAttributes,
            maxSelections: vm.maxSelections,
            existingPKs: vm.existingPKs.length // ✅ NUEVO
        });

        // =====================================================
        // ✅ NUEVO: CHECK IF ROW IS ALREADY IMPORTED
        // =====================================================

        /**
         * Verifica si una fila ya fue importada comparando su PK con la lista de PKs existentes
         * @param {Object} row - La fila de datos
         * @returns {Boolean} true si ya está importada, false si no
         */
        vm.isRowAlreadyImported = function (row) {
            if (!vm.existingPKs || vm.existingPKs.length === 0) {
                return false;
            }

            // Obtener el valor de la PK de esta fila
            if (!vm.pkAttributes || vm.pkAttributes.length === 0) {
                return false;
            }

            var firstPkAttr = vm.pkAttributes[0];
            var pkValue = null;

            // Intentar obtener el valor de la PK
            if (firstPkAttr.column_metadata_name && row[firstPkAttr.column_metadata_name] !== undefined) {
                pkValue = row[firstPkAttr.column_metadata_name];
            } else if (row[firstPkAttr.name] !== undefined) {
                pkValue = row[firstPkAttr.name];
            } else {
                // Buscar case-insensitive
                var keys = Object.keys(row);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i].toLowerCase() === firstPkAttr.name.toLowerCase() ||
                        (firstPkAttr.column_metadata_name && keys[i].toLowerCase() === firstPkAttr.column_metadata_name.toLowerCase())) {
                        pkValue = row[keys[i]];
                        break;
                    }
                }
            }

            if (pkValue === null || pkValue === undefined) {
                return false;
            }

            // Convertir a string para comparar
            var pkValueStr = String(pkValue);

            // Verificar si está en la lista de PKs existentes
            var isImported = vm.existingPKs.indexOf(pkValueStr) !== -1;

            if (isImported) {
                console.log('🔒 Row already imported:', pkValueStr);
            }

            return isImported;
        };

        // =====================================================
        // ✅ ACTUALIZADO: EXTRACT VALUE FROM JSON USING JSONPATH-PLUS
        // =====================================================

        /**
         * Extrae un valor de un objeto JSON usando un JSON Path con soporte para arrays
         * Usa JSONPath-Plus para evaluar paths complejos como: environments[0].name
         * @param {Object|String} jsonObject - El objeto JSON del cual extraer el valor
         * @param {String} jsonPath - El path en formato JSONPath (ej: "environments[0].name", "user.profile.name")
         * @returns {*} El valor extraído o null si no se encuentra
         */
        vm.extractValueFromJsonPath = function (jsonObject, jsonPath) {
            if (!jsonObject || !jsonPath) {
                console.warn('⚠️ extractValueFromJsonPath: Missing jsonObject or jsonPath');
                return null;
            }

            try {
                // Verificar que JSONPath-Plus esté disponible
                if (typeof JSONPath === 'undefined' || typeof JSONPath.JSONPath !== 'function') {
                    console.error('❌ JSONPath library not loaded!');
                    console.error('   typeof JSONPath:', typeof JSONPath);

                    // Fallback: intentar dot notation simple (sin arrays)
                    console.warn('⚠️ Falling back to simple dot notation parser (no array support)');
                    return vm.extractValueSimplePath(jsonObject, jsonPath);
                }

                // Si jsonObject es un string, parsearlo primero
                var parsedObject = jsonObject;
                if (typeof jsonObject === 'string') {
                    try {
                        parsedObject = JSON.parse(jsonObject);
                    } catch (parseError) {
                        console.error('❌ Error parsing JSON string:', parseError);
                        return null;
                    }
                }

                // Convertir path a formato JSONPath si no tiene el prefijo $
                var jsonPathQuery = jsonPath;
                if (!jsonPath.startsWith('$')) {
                    jsonPathQuery = '$.' + jsonPath;
                }

                console.log('[DatabasePicker][extractValueFromJsonPath] Evaluating path:', jsonPath, '→', jsonPathQuery);

                // Usar JSONPath-Plus para evaluar
                var result = JSONPath.JSONPath({
                    path: jsonPathQuery,
                    json: parsedObject,
                    wrap: false
                });

                console.log('[DatabasePicker][extractValueFromJsonPath] Raw result:', result);
                console.log('[DatabasePicker][extractValueFromJsonPath] Result type:', typeof result);

                // Manejar diferentes tipos de resultados
                if (result === undefined || result === null) {
                    console.warn('⚠️ Path returned undefined/null:', jsonPath);
                    return null;
                }

                // Si es un array vacío, retornar null
                if (Array.isArray(result) && result.length === 0) {
                    console.warn('⚠️ Path returned empty array:', jsonPath);
                    return null;
                }

                // Si es un array con un solo elemento, extraer ese elemento
                if (Array.isArray(result) && result.length === 1) {
                    console.log('📦 Unwrapping single-element array');
                    result = result[0];
                }

                console.log('[DatabasePicker][extractValueFromJsonPath] ✅ Final result:', result);
                return result;

            } catch (error) {
                console.error('❌ Error extracting value from JSON path:', error);
                console.error('   JSON Object:', jsonObject);
                console.error('   JSON Path:', jsonPath);
                return null;
            }
        };

        /**
         * Fallback: Extrae valor usando dot notation simple (SIN soporte para arrays)
         * Solo se usa si JSONPath-Plus no está disponible
         * @param {Object} obj - El objeto JSON
         * @param {String} path - El path en dot notation (ej: "user.profile.name")
         * @returns {*} El valor extraído o null
         */
        vm.extractValueSimplePath = function (obj, path) {
            console.warn('⚠️ [FALLBACK] Using simple dot notation (no array support)');

            if (!obj || !path) {
                return null;
            }

            try {
                // Si obj es un string, parsearlo
                var parsedObject = obj;
                if (typeof obj === 'string') {
                    parsedObject = JSON.parse(obj);
                }

                // Si el path contiene brackets, advertir que no se soporta
                if (path.includes('[')) {
                    console.error('❌ Path contains array notation but JSONPath-Plus is not available!');
                    console.error('   Path:', path);
                    console.error('   This path will NOT work without JSONPath-Plus');
                    return null;
                }

                // Split por puntos y navegar
                var pathParts = path.split('.');
                var currentValue = parsedObject;

                for (var i = 0; i < pathParts.length; i++) {
                    var part = pathParts[i];

                    if (currentValue === null || currentValue === undefined) {
                        console.warn('⚠️ Path not found at:', pathParts.slice(0, i + 1).join('.'));
                        return null;
                    }

                    if (typeof currentValue !== 'object') {
                        console.warn('⚠️ Cannot navigate further, not an object at:', pathParts.slice(0, i).join('.'));
                        return null;
                    }

                    currentValue = currentValue[part];
                }

                return currentValue;

            } catch (error) {
                console.error('❌ Error in fallback path extraction:', error);
                return null;
            }
        };

        // =====================================================
        // ✅ NUEVO: GET RESOURCE NAME VALUE
        // =====================================================

        /**
         * Obtiene el valor a mostrar para Resource Name
         * Si el atributo NO es JSON, devuelve el valor directo de la columna
         * Si el atributo ES JSON, extrae el valor usando resourceNameJsonPath
         * @param {Object} row - La fila de datos de la base
         * @param {Object} attribute - El atributo configurado como Resource Name
         * @returns {String} El valor a mostrar
         */
        vm.getResourceNameValue = function (row, attribute) {
            if (!row || !attribute) {
                return '-';
            }

            var columnName = attribute.column_metadata_name || attribute.name;
            var rawValue = row[columnName] || row[columnName.toLowerCase()];

            // Si el atributo NO es JSON, devolver el valor directamente
            if (attribute.scalar_attribute_type !== 'JSON') {
                return rawValue !== null && rawValue !== undefined ? rawValue : '-';
            }

            // Si es JSON, extraer usando el JSON Path
            if (!attribute.resourceNameJsonPath) {
                console.warn('⚠️ Resource Name is JSON but no resourceNameJsonPath configured');
                return '-';
            }

            var extractedValue = vm.extractValueFromJsonPath(rawValue, attribute.resourceNameJsonPath);
            return extractedValue !== null && extractedValue !== undefined ? extractedValue : '-';
        };

        // =====================================================
        // ✅ NUEVO: GET RESOURCE DESCRIPTION VALUE
        // =====================================================

        /**
         * Obtiene el valor a mostrar para Resource Description
         * Si el atributo NO es JSON, devuelve el valor directo de la columna
         * Si el atributo ES JSON, extrae el valor usando resourceDescriptionJsonPath
         * @param {Object} row - La fila de datos de la base
         * @param {Object} attribute - El atributo configurado como Resource Description
         * @returns {String} El valor a mostrar
         */
        vm.getResourceDescriptionValue = function (row, attribute) {
            if (!row || !attribute) {
                return '-';
            }

            var columnName = attribute.column_metadata_name || attribute.name;
            var rawValue = row[columnName] || row[columnName.toLowerCase()];

            // Si el atributo NO es JSON, devolver el valor directamente
            if (attribute.scalar_attribute_type !== 'JSON') {
                return rawValue !== null && rawValue !== undefined ? rawValue : '-';
            }

            // Si es JSON, extraer usando el JSON Path
            if (!attribute.resourceDescriptionJsonPath) {
                console.warn('⚠️ Resource Description is JSON but no resourceDescriptionJsonPath configured');
                return '-';
            }

            var extractedValue = vm.extractValueFromJsonPath(rawValue, attribute.resourceDescriptionJsonPath);
            return extractedValue !== null && extractedValue !== undefined ? extractedValue : '-';
        };

        // =====================================================
        // ✅ NUEVO: GET RESOURCE NAME ATTRIBUTE
        // =====================================================

        /**
         * Retorna el atributo que está marcado como Resource Name (isResourceNameField = true)
         * @returns {Object|undefined} El atributo de Resource Name o undefined si no existe
         */
        vm.getResourceNameAttribute = function () {
            return vm.resourceAttributes.find(function (attr) {
                return attr.isResourceNameField === true;
            });
        };

        // =====================================================
        // ✅ NUEVO: GET RESOURCE DESCRIPTION ATTRIBUTE
        // =====================================================

        /**
         * Retorna el atributo que está marcado como Resource Description (isResourceDescriptionField = true)
         * @returns {Object|undefined} El atributo de Resource Description o undefined si no existe
         */
        vm.getResourceDescriptionAttribute = function () {
            return vm.resourceAttributes.find(function (attr) {
                return attr.isResourceDescriptionField === true;
            });
        };

        // =====================================================
        // EXISTING FUNCTIONS (sin cambios)
        // =====================================================

        vm.isJsonColumn = function (columnName) {
            if (!columnName) return false;

            return vm.resourceAttributes.some(function (attr) {
                var attrColumnName = attr.column_metadata_name || attr.name;
                return attrColumnName.toLowerCase() === columnName.toLowerCase() &&
                    attr.scalar_attribute_type === 'JSON';
            });
        };

        /** JSON cell: template type JSON, or a value that already arrived as an object/array. */
        vm.isJsonCell = function (columnName, value) {
            return vm.isJsonColumn(columnName) || (value !== null && typeof value === 'object');
        };

        /** Short one-line preview for the cell chip. */
        vm.jsonPreview = function (value) {
            if (value === null || value === undefined || value === '') { return 'null'; }
            var text = typeof value === 'string' ? value : JSON.stringify(value);
            return text.length > 40 ? text.substring(0, 39) + '…' : text;
        };

        vm.openJsonViewer = function (event, value, columnName) {
            if (event) { event.stopPropagation(); }
            vm.jsonViewer = {
                open: true,
                json: value,
                query: vm.highlightTerm,
                title: vm.envMapping.table_name + ' · ' + columnName
            };
        };

        vm.closeJsonViewer = function () {
            vm.jsonViewer.open = false;
        };

        // Escape closes only the viewer, not the picker (md-dialog listens for Escape too)
        var escapeKeyHandler = function (event) {
            if (event.key === 'Escape' && vm.jsonViewer.open) {
                event.stopPropagation();
                $scope.$apply(vm.closeJsonViewer);
            }
        };

        document.addEventListener('keydown', escapeKeyHandler, true);

        $scope.$on('$destroy', function () {
            pickerClosed = true;
            document.removeEventListener('keydown', escapeKeyHandler, true);
        });

        vm.initializeColumns = function () {
            console.log('🔧 Building columns from template attributes...');

            vm.columns = vm.resourceAttributes.map(function (attr, index) {
                return {
                    sequence: index + 1,
                    columnName: attr.column_metadata_name || attr.name,
                    attributeName: attr.name,
                    dataType: attr.scalar_attribute_type,
                    isPrimaryKey: attr.isPrimaryKey || false,
                    isSensitive: attr.isSensitive || false,
                    isResourceNameField: attr.isResourceNameField || false,
                    isResourceDescriptionField: attr.isResourceDescriptionField || false
                };
            });

            vm.allColumns = vm.columns.map(function (col) {
                return col.columnName;
            });

            // ✅ FIX: Deduplicate — evita ngRepeat:dupes cuando el mismo column_name
            // aparece más de una vez en resourceAttributes (ej: PK + atributo regular)
            var seen = {};
            vm.allColumns = vm.allColumns.filter(function (colName) {
                if (seen[colName]) {
                    console.warn('⚠️ Duplicate column removed from allColumns:', colName);
                    return false;
                }
                seen[colName] = true;
                return true;
            });

            vm.allColumns.sort(function (a, b) {
                var aIsPK = vm.isPrimaryKeyColumn(a);
                var bIsPK = vm.isPrimaryKeyColumn(b);
                var aIsName = vm.isResourceNameColumn(a);
                var bIsName = vm.isResourceNameColumn(b);
                var aIsDesc = vm.isResourceDescriptionColumn(a);
                var bIsDesc = vm.isResourceDescriptionColumn(b);

                if (aIsPK && !bIsPK) return -1;
                if (!aIsPK && bIsPK) return 1;

                if (aIsName && !bIsName) return -1;
                if (!aIsName && bIsName) return 1;

                if (aIsDesc && !bIsDesc) return -1;
                if (!aIsDesc && bIsDesc) return 1;

                return a.localeCompare(b);
            });

            console.log('📊 Total columns:', vm.columns.length);
            console.log('📊 All column names:', vm.allColumns);
            console.log('✅ Columns ordered: PK -> Name -> Description -> Rest');

            vm.loadData();
        };

        vm.calculateVisiblePages = function () {
            var pages = [];
            var maxVisible = 7;
            var halfVisible = Math.floor(maxVisible / 2);

            if (vm.totalPages <= maxVisible) {
                for (var i = 1; i <= vm.totalPages; i++) {
                    pages.push(i);
                }
            } else {
                pages.push(1);

                var startPage, endPage;

                if (vm.page <= halfVisible + 1) {
                    startPage = 2;
                    endPage = maxVisible - 1;
                } else if (vm.page >= vm.totalPages - halfVisible) {
                    startPage = vm.totalPages - (maxVisible - 2);
                    endPage = vm.totalPages - 1;
                } else {
                    startPage = vm.page - halfVisible + 1;
                    endPage = vm.page + halfVisible - 1;
                }

                if (startPage > 2) {
                    pages.push('...');
                }

                for (var j = startPage; j <= endPage; j++) {
                    pages.push(j);
                }

                if (endPage < vm.totalPages - 1) {
                    pages.push('...');
                }

                pages.push(vm.totalPages);
            }

            vm.visiblePages = pages;
            console.log('📄 Visible pages calculated:', vm.visiblePages);

            $timeout(function () {
                $scope.$apply();
            }, 0);
        };

        vm.loadData = function () {
            if (vm.columns.length === 0) {
                console.warn('⚠️ No columns available, waiting...');
                return;
            }

            vm.loading = true;
            var requestId = ++loadSequence;
            var offset = (vm.page - 1) * vm.pageSize;

            var columnsForRequest = vm.columns.map(function (col) {
                return {
                    sequence: col.sequence,
                    columnName: col.columnName
                };
            });

            var orderByColumn = vm.pkAttributes && vm.pkAttributes.length > 0
                ? (vm.pkAttributes[0].column_metadata_name || vm.pkAttributes[0].name)
                : null;

            var options = angular.extend({
                limit: vm.pageSize,
                offset: offset
            }, vm.getSearchOptions());

            if (orderByColumn) {
                options.orderBy = orderByColumn;
                options.orderDirection = 'ASC';
                console.log('🔄 Sorting by primary key:', orderByColumn, 'ASC');
            }

            console.log('📤 Requesting table data - Page:', vm.page, 'PageSize:', vm.pageSize);

            DatasourceService.getTableData(
                vm.envMapping.datasource_id,
                vm.envMapping.schema_name,
                vm.envMapping.table_name,
                columnsForRequest,
                options
            ).then(function (response) {
                if (requestId !== loadSequence) { return; }
                console.log('✅ Table data loaded:', response);

                vm.rows = response.rows || [];
                vm.highlightTerm = options.searchText || '';
                vm.totalRows = response.totalRows || 0;

                // ✅ NUEVO: Marcar filas ya importadas como deshabilitadas
                vm.rows.forEach(function (row) {
                    row._isAlreadyImported = vm.isRowAlreadyImported(row);
                });

                // ✅ NUEVO: Inicializar estado de visibilidad de datos sensibles
                vm.initializeSensitiveVisibility();

                // Restaurar selecciones previas
                vm.restoreSelections();

                if (vm.rows.length > 0) {
                    console.log('📊 First row columns:', Object.keys(vm.rows[0]));
                }

                // Actualizar información de paginación
                if (response.pagination) {
                    vm.totalPages = response.pagination.totalPages;
                    vm.hasNextPage = response.pagination.hasNextPage;
                    vm.hasPreviousPage = response.pagination.hasPreviousPage;
                    vm.page = response.pagination.currentPage;
                } else {
                    vm.totalPages = 1;
                    vm.hasNextPage = false;
                    vm.hasPreviousPage = false;
                }

                // Calcular páginas visibles y actualizar estado
                vm.calculateVisiblePages();
                vm.updateSelectAllState();

                vm.loading = false;

                console.log('✅ Data load complete - Total rows:', vm.totalRows, 'Page:', vm.page, '/', vm.totalPages);

            }).catch(function (error) {
                if (requestId !== loadSequence) { return; }
                console.error('❌ Error loading table data:', error);
                vm.loading = false;

                var errorMessage = 'Failed to load data from database.';
                if (error.data) {
                    if (typeof error.data === 'string') {
                        errorMessage = error.data;
                    } else if (error.data.error && error.data.message) {
                        errorMessage = dialogService.formatErrorMessage(error.data);
                    } else if (error.data.message) {
                        errorMessage = error.data.message;
                    }
                }

                dialogService.showErrorDialog('Database Error', errorMessage);
            });
        };

        vm.selectAllRecords = function () {
            if (vm.isLoadingAllRecords || vm.isMaxSelectionsReached()) { return; }
            vm.isLoadingAllRecords = true;
            var selectedKeys = new Set(vm.selectedRows.map(vm.getRowKey));
            var pending = [];
            var remaining = vm.maxSelections ? vm.maxSelections - vm.selectedRows.length : Infinity;
            var columns = vm.columns.map(function (col) {
                return { sequence: col.sequence, columnName: col.columnName };
            });
            var orderBy = vm.pkAttributes && vm.pkAttributes.length
                ? (vm.pkAttributes[0].column_metadata_name || vm.pkAttributes[0].name) : null;
            var searchOptions = vm.getSearchOptions(); // "Select All" selecciona sólo lo que matchea la búsqueda

            // The limit applies to eligible selections, not to scanned database rows.
            // Advance by the returned count, even if the datasource caps each page.
            function scan(offset) {
                var options = angular.extend({ limit: 1024, offset: offset }, searchOptions);
                if (orderBy) { options.orderBy = orderBy; options.orderDirection = 'ASC'; }
                return DatasourceService.getTableData(vm.envMapping.datasource_id,
                    vm.envMapping.schema_name, vm.envMapping.table_name, columns, options)
                    .then(function (response) {
                        if (pickerClosed) { return; }
                        var rows = response.rows || [];
                        rows.forEach(function (row) {
                            if (pending.length >= remaining || vm.isRowAlreadyImported(row)) { return; }
                            var key = vm.getRowKey(row);
                            if (!selectedKeys.has(key)) {
                                selectedKeys.add(key);
                                pending.push(row);
                            }
                        });
                        var nextOffset = offset + rows.length;
                        var total = response.totalRows != null ? response.totalRows : vm.totalRows;
                        if (rows.length && pending.length < remaining && nextOffset < total) {
                            return scan(nextOffset);
                        }
                    });
            }

            return scan(0).then(function () {
                if (pickerClosed) { return; }
                // Commit only after the scan succeeds; failures leave the previous selection intact.
                vm.selectedRows = vm.selectedRows.concat(pending);
                vm.restoreSelections();
                vm.updateSelectAllState();
                var message = pending.length + ' record(s) selected';
                if (!pending.length) { message = 'No pending records available to select'; }
                else if (vm.isMaxSelectionsReached()) { message += ' (maximum reached)'; }
                $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(3000));
            }).catch(function (error) {
                if (!pickerClosed) {
                    dialogService.showErrorDialog('Database Error',
                        'Could not complete the selection. Please retry; your previous selection has been preserved.');
                }
            }).finally(function () {
                vm.isLoadingAllRecords = false;
            });
        };

        vm.getRowKey = function (row) {
            return JSON.stringify(vm.pkAttributes.map(function (pkAttr) {
                var name = pkAttr.column_metadata_name || pkAttr.column_name || pkAttr.name;
                var key = Object.keys(row).find(function (column) { return column.toLowerCase() === name.toLowerCase(); });
                return key === undefined ? null : row[key];
            }));
        };

        vm.restoreSelections = function () {
            vm.rows.forEach(function (row) {
                var rowKey = vm.getRowKey(row);
                var wasSelected = vm.selectedRows.some(function (selectedRow) {
                    return vm.getRowKey(selectedRow) === rowKey;
                });
                row._selected = wasSelected;
            });
        };

        vm.isMaxSelectionsReached = function () {
            return vm.maxSelections !== null && vm.selectedRows.length >= vm.maxSelections;
        };

        // ✅ ACTUALIZADO: No permitir selección de filas ya importadas
        vm.canSelectRow = function (row) {
            // Si ya está importada, no se puede seleccionar
            if (row._isAlreadyImported) {
                return false;
            }

            if (row._selected) {
                return true;
            }
            return !vm.isMaxSelectionsReached();
        };

        // ✅ ACTUALIZADO: Mostrar mensaje apropiado al intentar seleccionar fila importada
        vm.toggleRowSelection = function (row) {
            if (vm.isLoadingAllRecords) { return; }
            if (row._isAlreadyImported) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('This record has already been imported')
                        .position('top right')
                        .hideDelay(2000)
                );
                return;
            }

            if (!vm.canSelectRow(row)) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Maximum ' + vm.maxSelections + ' selection(s) reached')
                        .position('top right')
                        .hideDelay(2000)
                );
                return;
            }
            row._selected = !row._selected;
            vm.onCheckboxChange(row);
        };

        vm.onCheckboxChange = function (row) {
            if (vm.isLoadingAllRecords) { return; }
            var rowKey = vm.getRowKey(row);

            if (row._selected) {
                if (vm.isMaxSelectionsReached()) {
                    var exists = vm.selectedRows.some(function (selectedRow) {
                        return vm.getRowKey(selectedRow) === rowKey;
                    });

                    if (!exists) {
                        row._selected = false;
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Maximum ' + vm.maxSelections + ' selection(s) reached')
                                .position('top right')
                                .hideDelay(2000)
                        );
                        return;
                    }
                }

                var exists = vm.selectedRows.some(function (selectedRow) {
                    return vm.getRowKey(selectedRow) === rowKey;
                });

                if (!exists) {
                    vm.selectedRows.push(row);
                    console.log('✅ Row added to selection:', rowKey);
                }
            } else {
                vm.selectedRows = vm.selectedRows.filter(function (selectedRow) {
                    return vm.getRowKey(selectedRow) !== rowKey;
                });
                console.log('❌ Row removed from selection:', rowKey);
            }

            vm.updateSelectAllState();
            console.log('📊 Total selected rows:', vm.selectedRows.length);
        };

        // ✅ ACTUALIZADO: Solo seleccionar filas no importadas
        vm.toggleSelectAll = function () {
            if (vm.isLoadingAllRecords) { return; }
            if (vm.selectAll) {
                var remainingSlots = vm.maxSelections ? vm.maxSelections - vm.selectedRows.length : null;
                var rowsToSelect = 0;

                vm.rows.forEach(function (row) {
                    // Skip filas ya importadas
                    if (row._isAlreadyImported) {
                        return;
                    }

                    if (!row._selected) {
                        if (remainingSlots === null || rowsToSelect < remainingSlots) {
                            row._selected = true;
                            vm.onCheckboxChange(row);
                            rowsToSelect++;
                        }
                    }
                });

                if (vm.maxSelections && rowsToSelect < vm.rows.filter(function (r) { return !r._selected && !r._isAlreadyImported; }).length) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Maximum ' + vm.maxSelections + ' selection(s) reached')
                            .position('top right')
                            .hideDelay(2000)
                    );
                    vm.selectAll = false;
                }
            } else {
                vm.rows.forEach(function (row) {
                    if (row._selected) {
                        row._selected = false;
                        vm.onCheckboxChange(row);
                    }
                });
            }
        };

        // ✅ ACTUALIZADO: Excluir filas importadas del cálculo
        vm.updateSelectAllState = function () {
            if (vm.rows.length === 0) {
                vm.selectAll = false;
                return;
            }

            // Solo considerar filas que NO están importadas
            var selectableRows = vm.rows.filter(function (row) {
                return !row._isAlreadyImported;
            });

            if (selectableRows.length === 0) {
                vm.selectAll = false;
                return;
            }

            vm.selectAll = selectableRows.every(function (row) {
                return row._selected === true;
            });
        };

        vm.clearAllSelections = function () {
            if (vm.isLoadingAllRecords) { return; }
            vm.rows.forEach(function (row) {
                row._selected = false;
            });

            vm.selectedRows = [];
            vm.selectAll = false;

            console.log('✅ All selections cleared');

            $mdToast.show(
                $mdToast.simple()
                    .textContent('All selections cleared')
                    .position('top right')
                    .hideDelay(2000)
            );
        };

        vm.isRowSelected = function (row) {
            return row._selected === true;
        };

        /**
         * Opciones de búsqueda para getTableData: el texto se busca (contains, case-insensitive)
         * en las columnas visibles, excepto las sensibles, que se muestran ofuscadas.
         */
        vm.getSearchOptions = function () {
            var text = (vm.searchText || '').trim();
            if (!text) { return {}; }
            return {
                searchText: text,
                searchColumns: vm.columns
                    .filter(function (col) { return !col.isSensitive; })
                    .map(function (col) { return col.columnName; })
            };
        };

        vm.search = function () {
            console.log('🔍 Search triggered:', vm.searchText);
            vm.page = 1;
            vm.loadData();
        };

        vm.nextPage = function () {
            if (vm.hasNextPage) {
                console.log('➡️ Going to next page:', vm.page + 1);
                vm.page++;
                vm.loadData();
            }
        };

        vm.previousPage = function () {
            if (vm.hasPreviousPage) {
                console.log('⬅️ Going to previous page:', vm.page - 1);
                vm.page--;
                vm.loadData();
            }
        };

        vm.goToPage = function (pageNumber) {
            if (pageNumber >= 1 && pageNumber <= vm.totalPages && pageNumber !== vm.page) {
                console.log('🎯 Going to page:', pageNumber);
                vm.page = pageNumber;
                vm.loadData();
            }
        };

        vm.cancel = function () {
            pickerClosed = true;
            $mdDialog.cancel('user_cancelled');
        };

        vm.confirm = function () {
            if (vm.isLoadingAllRecords) { return; }
            if (vm.selectedRows.length === 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Please select at least one row')
                        .position('top right')
                        .hideDelay(2000)
                );
                return;
            }

            var results = vm.selectedRows.map(function (row) {
                var pkValues = vm.pkAttributes.map(function (pkAttr) {
                    var columnValue = null;

                    if (pkAttr.column_metadata_name && row[pkAttr.column_metadata_name] !== undefined) {
                        columnValue = row[pkAttr.column_metadata_name];
                    }
                    else if (row[pkAttr.name] !== undefined) {
                        columnValue = row[pkAttr.name];
                    }
                    else {
                        var keys = Object.keys(row);
                        for (var i = 0; i < keys.length; i++) {
                            if (keys[i].toLowerCase() === pkAttr.name.toLowerCase() ||
                                (pkAttr.column_metadata_name && keys[i].toLowerCase() === pkAttr.column_metadata_name.toLowerCase())) {
                                columnValue = row[keys[i]];
                                break;
                            }
                        }
                    }

                    return {
                        attributeId: pkAttr.id,
                        attributeName: pkAttr.name,
                        attributeValue: columnValue !== null && columnValue !== undefined ? String(columnValue) : ''
                    };
                });

                return {
                    primaryKeys: pkValues,
                    fullRowData: angular.copy(row)
                };
            });

            console.log('✅ Selected rows count:', results.length);
            console.log('✅ Complete selection data:', results);

            $mdDialog.hide(results);
        };

        vm.isPrimaryKeyColumn = function (columnName) {
            if (!columnName) return false;

            return vm.pkAttributes.some(function (pkAttr) {
                return pkAttr.name.toLowerCase() === columnName.toLowerCase() ||
                    (pkAttr.column_metadata_name && pkAttr.column_metadata_name.toLowerCase() === columnName.toLowerCase());
            });
        };

        vm.isResourceNameColumn = function (columnName) {
            if (!columnName) return false;

            return vm.resourceAttributes.some(function (attr) {
                var attrColumnName = attr.column_metadata_name || attr.name;
                return attrColumnName.toLowerCase() === columnName.toLowerCase() &&
                    attr.isResourceNameField === true;
            });
        };

        vm.isResourceDescriptionColumn = function (columnName) {
            if (!columnName) return false;

            return vm.resourceAttributes.some(function (attr) {
                var attrColumnName = attr.column_metadata_name || attr.name;
                return attrColumnName.toLowerCase() === columnName.toLowerCase() &&
                    attr.isResourceDescriptionField === true;
            });
        };

        vm.getAttributeByColumnName = function (columnName) {
            if (!columnName) return null;

            return vm.resourceAttributes.find(function (attr) {
                var attrColumnName = attr.column_metadata_name || attr.name;
                return attrColumnName.toLowerCase() === columnName.toLowerCase();
            });
        };

        vm.pkValue = function (row, pkAttr) {
            return row[pkAttr.column_name] || row[pkAttr.column_name.toLowerCase()] || '-';
        };

        vm.formatUUID = function (value) {
            if (!value || value === '-') {
                return value;
            }

            var strValue = String(value);

            var uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

            if (uuidPattern.test(strValue)) {
                var withoutDashes = strValue.replace(/-/g, '');
                return '...' + withoutDashes.slice(-10);
            }

            return strValue;
        };

        vm.changePageSize = function () {
            console.log('📏 Page size changed to:', vm.pageSize);
            vm.page = 1;
            vm.loadData();
        };

        // Initial setup
        vm.initializeColumns();

        // =====================================================
        // ✅ NUEVO: SENSITIVE DATA HANDLING
        // =====================================================

        /**
         * Verifica si una columna es sensible
         * @param {String} columnName - Nombre de la columna
         * @returns {Boolean} true si es sensible, false si no
         */
        vm.isSensitiveColumn = function (columnName) {
            if (!columnName) return false;

            return vm.resourceAttributes.some(function (attr) {
                var attrColumnName = attr.column_metadata_name || attr.name;
                return attrColumnName.toLowerCase() === columnName.toLowerCase() &&
                    attr.isSensitive === true;
            });
        };

        /**
         * Inicializa el estado de visibilidad de datos sensibles para cada fila
         * Crea un objeto _sensitiveVisible en cada fila con el formato:
         * { columnName: false, columnName2: false, ... }
         */
        vm.initializeSensitiveVisibility = function () {
            vm.rows.forEach(function (row) {
                if (!row._sensitiveVisible) {
                    row._sensitiveVisible = {};
                }

                // Inicializar todas las columnas sensibles como ocultas
                vm.resourceAttributes.forEach(function (attr) {
                    if (attr.isSensitive) {
                        var columnName = attr.column_metadata_name || attr.name;
                        if (row._sensitiveVisible[columnName] === undefined) {
                            row._sensitiveVisible[columnName] = false;
                        }
                    }
                });
            });
        };

        /**
         * Toggle de visibilidad para un valor sensible específico
         * @param {Event} event - El evento click
         * @param {Object} row - La fila de datos
         * @param {String} columnName - Nombre de la columna
         */
        vm.toggleSensitiveVisibility = function (event, row, columnName) {
            event.stopPropagation(); // Evitar que se active el click de la fila

            if (!row._sensitiveVisible) {
                row._sensitiveVisible = {};
            }

            // Toggle del estado
            row._sensitiveVisible[columnName] = !row._sensitiveVisible[columnName];

            console.log('👁️ Toggled sensitive visibility for:', columnName, '→', row._sensitiveVisible[columnName]);
        };

        /**
         * Verifica si un valor sensible está visible
         * @param {Object} row - La fila de datos
         * @param {String} columnName - Nombre de la columna
         * @returns {Boolean} true si está visible, false si está oculto
         */
        vm.isSensitiveVisible = function (row, columnName) {
            if (!row._sensitiveVisible) {
                return false;
            }
            return row._sensitiveVisible[columnName] === true;
        };

        /**
         * Ofusca un valor sensible
         * @param {*} value - El valor a ofuscar
         * @returns {String} El valor ofuscado
         */
        vm.obfuscateValue = function (value) {
            if (value === null || value === undefined || value === '-') {
                return '-';
            }

            var strValue = String(value);

            // Si es muy corto (menos de 4 caracteres), mostrar solo asteriscos
            if (strValue.length < 4) {
                return '***';
            }

            // Mostrar primeros 2 y últimos 2 caracteres, resto con asteriscos
            var visibleChars = 2;
            var start = strValue.substring(0, visibleChars);
            var end = strValue.substring(strValue.length - visibleChars);
            var middle = '*'.repeat(Math.min(strValue.length - (visibleChars * 2), 8)); // Máximo 8 asteriscos

            return start + middle + end;
        };

        /**
         * Obtiene el valor a mostrar para una columna sensible
         * @param {Object} row - La fila de datos
         * @param {String} columnName - Nombre de la columna
         * @returns {String} El valor (ofuscado o real según visibilidad)
         */
        vm.getSensitiveDisplayValue = function (row, columnName) {
            var rawValue = row[columnName] || row[columnName.toLowerCase()];

            if (vm.isSensitiveVisible(row, columnName)) {
                // Mostrar valor real
                return rawValue !== null && rawValue !== undefined ? rawValue : '-';
            } else {
                // Mostrar valor ofuscado
                return vm.obfuscateValue(rawValue);
            }
        };
    });

